import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isEditNpcEntry: false, loading: false };

export const editNpcEntryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.EDIT_NPC_ENTRY_SUCCESS:
      return { ...state, isEditNpcEntry: true, response: action.payload, loading: false };
    case npcLogConstant.EDIT_NPC_ENTRY_FAILURE:
      return { ...state, isEditNpcEntry: false, response: action.payload, loading: false };
    case npcLogConstant.EDIT_NPC_ENTRY_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.EDIT_NPC_ENTRY_RESET:
      return initialState;
    default:
      return state;
  }
};
